<div class="valben-card flex flex-col max-h-[calc(100vh-140px)] overflow-hidden">

    <div class="valben-toolbar">
        <button type="button" class="valben-button valben-button--lead" (click)="onRefresh()">
            <mat-icon>refresh</mat-icon>
            <span>Osvježi</span>
        </button>

        <div class="valben-search">
            <mat-icon class="valben-search-icon">search</mat-icon>
            <input
                type="text"
                placeholder="Traži u svim stupcima"
                [ngModel]="globalFilter()"
                (ngModelChange)="onGlobalFilter($event)" />
            @if (globalFilter()) {
                <button
                    type="button"
                    class="valben-search-clear"
                    aria-label="Očisti pretragu"
                    (click)="onGlobalFilter('')">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </div>

        <span class="grow"></span>

        @if (addLabel()) {
            <button type="button" class="valben-add-button" (click)="addEvent.emit()">
                <mat-icon>add</mat-icon>
                <span>{{ addLabel() }}</span>
            </button>
        }

        <button
            type="button"
            class="valben-toolbar-icon"
            aria-label="Upute"
            matTooltip="Upute"
            (click)="openPdfFile('CMS-manual.pdf')">
            <mat-icon>help_outline</mat-icon>
        </button>
    </div>

    <div class="relative flex-1 min-h-0 overflow-auto">
        @if (loading()) {
            <div
                class="absolute left-0 right-0 bottom-0 top-[4.5rem] flex items-center justify-center pointer-events-none z-[4]">
                <mat-spinner [diameter]="32"></mat-spinner>
            </div>
        }

        <table
            mat-table
            [class.is-loading]="loading()"
            [dataSource]="displayRows()"
            [trackBy]="trackByRow"
            matSort
            [matSortActive]="sortField()"
            [matSortDirection]="sortDir()"
            matSortDisableClear
            (matSortChange)="onSort($event)">

            @for (col of bodyColumns(); track col.field) {
            <ng-container [matColumnDef]="col.field">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="valben-th"
                    [class.is-centered]="isCentered(col)"
                    [class.is-sorted]="thSorted(col)"
                    [class.is-filtered]="thFiltered(col)">
                    <div class="valben-th-stack" [style.width.px]="isResizable(col) ? widthOf(col) : null">
                        <ng-container
                            [ngTemplateOutlet]="thLine"
                            [ngTemplateOutletContext]="{ col: col, secondary: false }"></ng-container>
                        @if (pairOf(col); as pair) {
                            <ng-container
                                [ngTemplateOutlet]="thLine"
                                [ngTemplateOutletContext]="{ col: pair, secondary: true }"></ng-container>
                        }
                    </div>

                    @if (isResizable(col)) {
                        <span
                            class="valben-resize-handle"
                            cdkDrag
                            cdkDragLockAxis="x"
                            #resize="cdkDrag"
                            (cdkDragStarted)="onResizeStart(col)"
                            (cdkDragMoved)="onResizeMove(col, $event)"
                            (cdkDragEnded)="resize.reset()"></span>
                    }
                </th>

                <td mat-cell *matCellDef="let row" [class.is-centered]="isCentered(col)">
                    <div class="valben-cell-stack">
                        <ng-container
                            [ngTemplateOutlet]="cellLine"
                            [ngTemplateOutletContext]="{ col: col, row: row, width: widthOf(col), secondary: false }"></ng-container>
                        @if (pairOf(col); as pair) {
                            <ng-container
                                [ngTemplateOutlet]="cellLine"
                                [ngTemplateOutletContext]="{ col: pair, row: row, width: widthOf(col), secondary: true }"></ng-container>
                        }
                    </div>
                </td>
            </ng-container>
            }

            @if (hasActions()) {
            <ng-container [matColumnDef]="actionsColumn">
                <th mat-header-cell *matHeaderCellDef class="valben-th valben-th--actions">
                    <div class="valben-actions-heading">
                        <span class="valben-th-caption">Prikaz · Akcije</span>
                        @if (actionFilterColumns().length) {
                            <span class="valben-th-tools">
                                @for (col of actionFilterColumns(); track col.field) {
                                    <ng-container
                                        [ngTemplateOutlet]="filterControl"
                                        [ngTemplateOutletContext]="{ col: col }"></ng-container>
                                }
                            </span>
                        }
                    </div>
                </th>
                <td mat-cell *matCellDef="let row" class="valben-td--actions">
                    @if (!loading()) {
                        <div class="valben-actions">
                            @for (col of actionColumns(); track col.field) {
                                @switch (col.bodyType) {
                                    @case ('link') {
                                        @if (row[col.field]) {
                                            <a
                                                class="valben-row-action"
                                                [href]="row[col.field]"
                                                [attr.aria-label]="col.header"
                                                [matTooltip]="row[col.field]"
                                                target="_blank">
                                                <mat-icon>{{ iconFor(col) }}</mat-icon>
                                            </a>
                                        }
                                    }
                                    @case ('file') {
                                        <valben-file-modal
                                            [src]="row[col.field]"
                                            [icon]="iconFor(col)"
                                            [tooltip]="col.header" />
                                    }
                                    @case ('map') {
                                        <valben-map-modal
                                            [data]="row[col.field]"
                                            [icon]="iconFor(col)"
                                            [tooltip]="col.header" />
                                    }
                                    @case ('modal') {
                                        <valben-expand-modal
                                            [data]="row[col.field]"
                                            [icon]="iconFor(col)"
                                            [tooltip]="col.header"
                                            [emptyMessage]="col.filterType === 'locs' ? 'Lokacija neodređena.' : 'Kategorija neodređena.'" />
                                    }
                                    @case ('kngEvaluation') {
                                        <valben-superior-evaluation-modal
                                            [data]="row[col.field]"
                                            [icon]="iconFor(col)"
                                            [tooltip]="col.header" />
                                    }
                                    @case ('landlordData') {
                                        <valben-landlord-data-modal
                                            [data]="row[col.field]"
                                            [icon]="iconFor(col)"
                                            [tooltip]="col.header"
                                            (saveChanges)="landlordDataSave.emit({ masterId: row['masterId'], version: row['version'], data: $event })" />
                                    }
                                }
                            }

                            @if (showKngContracts()) {
                                <button
                                    type="button"
                                    class="valben-row-action"
                                    aria-label="Ugovori"
                                    matTooltip="Ugovori"
                                    (click)="openContracts(row)">
                                    <mat-icon>folder_shared</mat-icon>
                                </button>
                            }

                            @if (showHistory()) {
                                <valben-history [masterId]="row['masterId']" />
                            }

                            @if (showEdit()) {
                                <button type="button" class="valben-edit-button" (click)="editEvent.emit(row['masterId'])">
                                    <span>{{ editText() }}</span>
                                    <mat-icon>arrow_forward</mat-icon>
                                </button>
                            }

                        </div>
                    }
                </td>
            </ng-container>
            }

            <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="py-10 px-4 text-center text-gray-500 text-sm" [attr.colspan]="displayedColumns().length">Nema podataka.</td>
            </tr>

            <!-- Must stay inside the table: mat-sort-header resolves matSort through this template's declaration injector. -->
            <ng-template #thLine let-col="col" let-secondary="secondary">
                <div class="valben-th-line" [class.is-secondary]="secondary">
                    <span
                        class="valben-th-label"
                        [class.is-sorted]="isSortedCol(col)"
                        [mat-sort-header]="sortKey(col)"
                        [disabled]="!col.sortable">{{ col.header }}</span>

                    <span class="valben-th-tools">
                        <ng-container
                            [ngTemplateOutlet]="filterControl"
                            [ngTemplateOutletContext]="{ col: col }"></ng-container>
                        @if (col.bodyType === 'langs') {
                            <button
                                type="button"
                                class="valben-language-button"
                                [attr.aria-label]="'Odaberi jezik za ' + col.header"
                                [matMenuTriggerFor]="langMenu">{{ subFieldOf(col) }}</button>
                        }
                    </span>

                    <mat-menu #langMenu="matMenu" class="valben-menu valben-language-menu">
                        <ng-template matMenuContent>
                            @for (lang of values() | langsDistinct: col.field; track lang) {
                                <button mat-menu-item (click)="setSubField(col, lang)">
                                    <span class="valben-language-option">
                                        <mat-icon>{{ lang === subFieldOf(col) ? "check" : "" }}</mat-icon>
                                        <span>{{ lang }}</span>
                                    </span>
                                </button>
                            }
                        </ng-template>
                    </mat-menu>

                </div>
            </ng-template>

            <ng-template #filterControl let-col="col">
                @if (col.filterType) {
                    <button
                        type="button"
                        class="valben-filter-button"
                        [class.is-active]="hasFilter(col)"
                        [attr.aria-label]="'Filtriraj ' + col.header"
                        [matTooltip]="col.header"
                        [matMenuTriggerFor]="filterMenu">
                        <mat-icon>filter_alt</mat-icon>
                    </button>

                    <mat-menu #filterMenu="matMenu" class="valben-menu">
                        <ng-template matMenuContent>
                        <div
                            class="flex flex-col gap-2.5 p-3.5 min-w-[15rem]"
                            (click)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()">
                            <p class="text-xs font-semibold uppercase tracking-[0.04em] text-gray-500">{{ col.header }}</p>

                            @if (col.filterType === 'text') {
                                <input
                                    type="text"
                                    class="valben-input"
                                    placeholder="Sadrži..."
                                    [ngModel]="filterValue(col)"
                                    (ngModelChange)="onFilter(col, $event)" />
                            }

                            @if (col.filterType === 'numeric') {
                                <input
                                    type="number"
                                    class="valben-input"
                                    placeholder="Vrijednost"
                                    [ngModel]="filterValue(col)"
                                    (ngModelChange)="onFilter(col, $event)" />
                            }

                            @if (col.filterType === 'date') {
                                <input
                                    type="date"
                                    class="valben-input"
                                    [ngModel]="filterValue(col)"
                                    (ngModelChange)="onFilter(col, $event, true)" />
                            }

                            @if (col.filterType === 'boolean') {
                                <div class="grid grid-cols-3 gap-1 p-[0.1875rem] bg-valamargray rounded-lg">
                                    <button
                                        type="button"
                                        class="valben-choice"
                                        [class.is-selected]="filterValue(col) === undefined"
                                        (click)="onFilter(col, undefined, true)">Sve</button>
                                    <button
                                        type="button"
                                        class="valben-choice"
                                        [class.is-selected]="filterValue(col) === true"
                                        (click)="onFilter(col, true, true)">Da</button>
                                    <button
                                        type="button"
                                        class="valben-choice"
                                        [class.is-selected]="filterValue(col) === false"
                                        (click)="onFilter(col, false, true)">Ne</button>
                                </div>
                            }

                            @if (isMultiFilter(col)) {
                                <div class="flex flex-col gap-0.5 max-h-56 overflow-y-auto">
                                    @for (option of optionsFor(col); track option) {
                                    <label
                                        class="flex items-center gap-2 py-0.5 px-1 rounded-md text-sm cursor-pointer hover:bg-valamargray">
                                        <mat-checkbox
                                            [checked]="isChecked(col, option)"
                                            (change)="toggleOption(col, option, $event.checked)"></mat-checkbox>
                                        <span>{{ option }}</span>
                                    </label>
                                    }
                                    @if (!optionsFor(col).length) {
                                        <p class="p-1 text-[0.8125rem] text-gray-500">Nema opcija.</p>
                                    }
                                </div>
                            }

                            <button
                                type="button"
                                class="valben-clear-filter"
                                [disabled]="!hasFilter(col)"
                                (click)="clearFilter(col)">Očisti filter</button>
                        </div>
                        </ng-template>
                    </mat-menu>
                }
            </ng-template>

            <ng-template #cellLine let-col="col" let-row="row" let-width="width" let-secondary="secondary">
                @if (loading()) {
                    <span class="valben-skeleton" [style.width.px]="width"></span>
                } @else {
                    <div class="valben-cell-line" [class.is-secondary]="secondary">
                        @if (col.prefix) {
                            <span class="valben-prefix" [class.is-tight]="col.bodyType === 'number'">{{ col.prefix }}</span>
                        }

                        @switch (col.bodyType) {
                            @case ('boolean') {
                                @if (col.trueText || col.falseText) {
                                    <span
                                        class="valben-flag"
                                        [class.is-pill]="!secondary"
                                        [class.is-true]="row[col.field]"
                                        [class.is-false]="!row[col.field]">
                                        <mat-icon>{{ row[col.field] ? "check_circle" : (secondary ? "remove" : "highlight_off") }}</mat-icon>
                                        <span>{{ row[col.field] ? (col.trueText ?? "Da") : (col.falseText ?? "Ne") }}</span>
                                    </span>
                                } @else {
                                    <span class="valben-boolean-value" [attr.title]="row[col.field] ? 'Da' : 'Ne'">
                                        <mat-icon
                                            class="valben-boolean-icon"
                                            [class.is-true]="row[col.field]"
                                            [class.is-false]="!row[col.field]">
                                            {{ row[col.field] ? "check_circle" : "highlight_off" }}
                                        </mat-icon>
                                    </span>
                                }
                            }
                            @case ('datetime') {
                                <span class="valben-stamp">
                                    <span>{{ row[col.field] | date: "dd.MM.yyyy." }}</span>
                                    <span class="valben-stamp-time">{{ row[col.field] | date: "HH:mm" }}</span>
                                </span>
                            }
                            @case ('date') {
                                <span>{{ row[col.field] ? (row[col.field] | date: "dd.MM.yyyy.") : "Neodređeno" }}</span>
                            }
                            @case ('number') {
                                <span class="tabular-nums">{{ row[col.field] }}</span>
                            }
                            @case ('text') {
                                <span
                                    class="valben-truncate"
                                    [style.maxWidth.px]="width"
                                    [title]="row[col.field]">{{ row[col.field] }}</span>
                            }
                            @case ('langs') {
                                <span
                                    class="valben-truncate"
                                    [style.maxWidth.px]="width"
                                    [title]="row[col.field][subFieldOf(col) ?? ''] | stripHtml">{{ row[col.field][subFieldOf(col) ?? ''] | stripHtml }}</span>
                            }
                            @case ('button') {
                                <button type="button" class="valben-button" (click)="col.buttonFn && col.buttonFn(row['masterId'])">
                                    {{ col.buttonText }}
                                </button>
                            }
                            @default {
                                <span>{{ row[col.field] }}</span>
                            }
                        }
                    </div>
                }
            </ng-template>
        </table>
    </div>

    @if (paginator()) {
        <div class="valben-footer">
            <span class="valben-footer-label">Stavki po stranici</span>
            <div class="valben-size-group">
                @for (size of rowsPerPageOptions(); track size) {
                    <button
                        type="button"
                        class="valben-size-option"
                        [class.is-selected]="pageSize() === size"
                        (click)="setPageSize(size)">{{ size }}</button>
                }
            </div>
            <span class="valben-footer-range">{{ rangeLabel() }}</span>
            <div class="valben-pager">
                <button
                    type="button"
                    class="valben-pager-button"
                    aria-label="Prethodna stranica"
                    [disabled]="pagerIndex() === 0"
                    (click)="goToPage(pagerIndex() - 1)">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button
                    type="button"
                    class="valben-pager-button"
                    aria-label="Sljedeća stranica"
                    [disabled]="pagerIndex() >= lastPageIndex()"
                    (click)="goToPage(pagerIndex() + 1)">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    }
</div>
